import cc from "classcat"

const H4 = ({
  children,
  textStyle = "gradient-green",
  textAlign,
  className = "",
}) => {
  return (
    <h4
      className={cc([
        "text-2xl leading-8 tracking-tight sm:text-3xl sm:leading-9",
        {
          "text-gradient-green": textStyle === "gradient-green",
          "text-zinc-200": textStyle === "light",
          "text-zinc-700": textStyle === "dark",
          "text-center": textAlign === "center",
          "text-left": textAlign === "left",
        },
        className,
      ])}
    >
      {children}
    </h4>
  )
}

export default H4
